<template>
  <div class="flex min-h-dvh items-center justify-center bg-surface-muted px-4 py-10">
    <div class="w-full max-w-sm">
      <slot />
    </div>
  </div>
</template>
